import React, {useState, createRef, useEffect, useRef} from 'react';
import dateformat from 'dateformat';
import TabItemContainer from '../../../Tabs/TabItemContainer';

import * as S from './WalletStatement.styles';

import IconSelector from '@ibibo/icon-selector';
import useOutsideClick from '@ibibo/use-outside-click';
import DownloadDropdown from '../../../common/DownloadDropdown/DownloadDropdown';
import CalendarBlock from './WalletCalendar';
import {useDispatch, useSelector} from 'react-redux';
import {
  updateWalletTypeTab,
  fetchWalletData,
  walletApi,
  activeWalletTypeSelector,
} from '@ibibo/myaccount-reducer';

const WalletStatementRow = ({item}) => (
  <tr>
    {Object.keys(item).map(key => (
      <td key={key}>{item[key] ? item[key] : '-'}</td>
    ))}
  </tr>
);

const WalletStatement = ({walletData, isLoading, updateDateParams, ccdeCookie, is_sub_user}) => {
  const dispatch = useDispatch();
  const dropDownRef = useRef();
  const walletTypeSelected = useSelector(activeWalletTypeSelector);
  const [walletTdaFlag, setWalletTdsFlag] = useState(true);
  const [dropDown, setDropDown] = useState(false);
  const [walletStatementDates, setDates] = useState({
    startDate: new Date(
      new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(),
      new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1,
      new Date().getDate(),
    ),
    endDate: new Date(),
  });

  let keys = [];

  if (walletData && walletData.length) {
    keys = Object.keys(walletData[0]);
  }

  const startDateRef = createRef();
  const endDateRef = createRef();
  const [calendarMode, setCalendarMode] = useState('');
  const [viewMobile, setViewMobile] = useState(false);
  let width = typeof window === 'undefined' ? 100 : window.screen.width;

  useEffect(() => {
    if (walletData && walletData.length) {
      keys = Object.keys(walletData[0]);
      const startDate = walletData[walletData.length - 1].Date;
      const endDate = walletData[0].Date;
      const startArr = startDate.split('/');
      const startDateObj = new Date(
        parseInt(startArr[2]),
        parseInt(startArr[1]) - 1,
        parseInt(startArr[0]),
      );
      const endArr = endDate.split('/');
      const endDateObj = new Date(
        parseInt(endArr[2]),
        parseInt(endArr[1]) - 1,
        parseInt(endArr[0]),
      );
      if (!walletStatementDates.startDate && !walletStatementDates.endDate) {
        setDates({
          startDate: startDateObj,
          endDate: endDateObj,
        });
      }
    }
  }, [walletData]);

  useEffect(() => {
    if (calendarMode === '' && walletStatementDates.startDate && walletStatementDates.endDate) {
      updateDateParams({
        startDate: dateformat(walletStatementDates.startDate, 'yyyy-mm-dd'),
        endDate: dateformat(walletStatementDates.endDate, 'yyyy-mm-dd'),
      });
    }
  }, [calendarMode]);
  useEffect(() => {
    if (width < 769) {
      setViewMobile(true);
    }
  }, [width]);

  const updateQueryCaller = data => {
    if (
      (data.startDate && data.startDate.toString() !== walletStatementDates.startDate.toString()) ||
      (data.endDate && data.endDate.toString() !== walletStatementDates.endDate.toString())
    ) {
      setDates({
        startDate: data.startDate,
        endDate: data.endDate,
      });
    }
  };

  const updateCalendarState = (event, key) => {
    event.stopPropagation();
    setCalendarMode(key);
  };

  useOutsideClick(startDateRef, () => {
    setCalendarMode('');
  });

  useOutsideClick(endDateRef, () => {
    setCalendarMode('');
  });

  const toggleDropDown = idx => {
    setDropDown(!dropDown);
    if (idx === 0) {
      window.open(statementPath, '_blank');
    }
    if (idx === 1) {
      window.open(tdsStatementPath, '_blank');
    }
  };

  useOutsideClick(dropDownRef, () => {
    if (dropDown) {
      setDropDown(false);
    }
  });

  let walletStartDate = dateformat(walletStatementDates.startDate, 'yyyy-mm-dd');
  let walletEndDate = dateformat(walletStatementDates.endDate, 'yyyy-mm-dd');

  let statementPath = `${walletApi}export_transaction/?from_date=${walletStartDate}&to_date=${walletEndDate}&statement_type=${walletTypeSelected}`;
  let tdsStatementPath = `${walletApi}export_transaction?statement_type=tds&from_date=${walletStartDate}&to_date=${walletEndDate}`;

  return (
    <S.StatementMainWrap>
      <S.StatementInnerWrap>
        <S.StatementHeadWrap>
          <S.StatementMobileHandle>
            <S.StatementHeadText>Wallet Statement</S.StatementHeadText>
            <TabItemContainer
              getActiveTab={tab => {
                dispatch(updateWalletTypeTab(tab));
                if (tab === 'Wallet') {
                  setWalletTdsFlag(true);
                } else {
                  setWalletTdsFlag(false);
                }
                dispatch(
                  fetchWalletData({
                    startDate: dateformat(walletStatementDates.startDate, 'yyyy-mm-dd'),
                    endDate: dateformat(walletStatementDates.endDate, 'yyyy-mm-dd'),
                  }),
                );
              }}
            >
              <S.TabContainerItem label="Wallet" />
              <S.TabContainerItem label="Promo" />
            </TabItemContainer>
          </S.StatementMobileHandle>
          {(
            <S.StatementTimeWrap>
              <S.StatementTimeInnerWrap>
                <S.FromTimeWrap onClick={e => updateCalendarState(e, 'start')}>
                  <S.FromTimeText>From</S.FromTimeText>
                  <S.FromTimeMainText>
                    {dateformat(walletStatementDates.startDate, 'dd/mm/yyyy')}
                  </S.FromTimeMainText>
                </S.FromTimeWrap>
                {(calendarMode === 'start' && (
                  <S.CalendarWrapperFrom>
                    <CalendarBlock
                      ref={startDateRef}
                      isSearchWidget={true}
                      isStartMode={calendarMode === 'start'}
                      isEndMode={calendarMode === 'end'}
                      onSelection={() => setCalendarMode('end')}
                      updateQueryCaller={updateQueryCaller}
                      startDate={walletStatementDates.startDate}
                      endDate={walletStatementDates.endDate}
                    />
                  </S.CalendarWrapperFrom>
                )) ||
                  null}
                <S.TimeBreakDiv />
                <S.FromTimeWrap onClick={e => updateCalendarState(e, 'end')}>
                  <S.FromTimeText>To</S.FromTimeText>
                  <S.FromTimeMainText>
                    {dateformat(walletStatementDates.endDate, 'dd/mm/yyyy')}
                  </S.FromTimeMainText>
                </S.FromTimeWrap>
                {(calendarMode === 'end' && (
                  <S.CalendarWrapperTo>
                    <CalendarBlock
                      ref={endDateRef}
                      isSearchWidget={true}
                      isStartMode={calendarMode === 'start'}
                      isEndMode={calendarMode === 'end'}
                      onSelection={() => setCalendarMode('')}
                      updateQueryCaller={updateQueryCaller}
                      startDate={walletStatementDates.startDate}
                      endDate={walletStatementDates.endDate}
                    />
                  </S.CalendarWrapperTo>
                )) ||
                  null}
              </S.StatementTimeInnerWrap>

              {!is_sub_user && ccdeCookie != 'AE' ? (
                walletTdaFlag ? (
                  <>
                    <S.DownloadIconWrap
                      onClick={e => {
                        setDropDown(dropDown => !dropDown);
                      }}
                    >
                      <IconSelector iconKey="downloadNew" />
                    </S.DownloadIconWrap>
                  </>
                ) : (
                  <S.DownloadIconWrap
                    href={statementPath}
                    target="_blank"
                    title="Download Statement"
                  >
                    <IconSelector iconKey="downloadNew" />
                  </S.DownloadIconWrap>
                )
              ) : (
                <>
                  <S.DownloadIconWrap
                    href={statementPath}
                    target="_blank"
                    title="Download Statement"
                  >
                    <IconSelector iconKey="downloadNew" />
                  </S.DownloadIconWrap>
                </>
              )}
            </S.StatementTimeWrap>
          ) || null}
        </S.StatementHeadWrap>
        {dropDown && (
          <DownloadDropdown
            options={['Download Wallet Statement', 'Download Wallet TDS Statement']}
            onSelectItem={toggleDropDown}
            ref={dropDownRef}
          />
        )}

        {(!viewMobile && (
          <S.StatementSummaryWrap>
            {(!keys.length && (
              <>
                {isLoading ? (
                  <IconSelector iconKey="linearloader" props={{top: '40%'}} />
                ) : (
                  <S.StatementBody>
                    <div>All your wallet transactions will be shown here</div>
                    <span>You haven’t done any wallet transaction for these dates.</span>
                  </S.StatementBody>
                )}
              </>
            )) ||
              null}
            {(keys.length && (
              <table>
                <thead>
                  <tr>
                    {keys.map(item => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {walletData.map((item, i) => (
                    <WalletStatementRow item={item} key={`walletItem${i}`} />
                  ))}
                </tbody>
              </table>
            )) ||
              null}
          </S.StatementSummaryWrap>
        )) || (
          <S.StatementMobileWrap>
            {(!keys.length && (
              <>
                {isLoading ? (
                  <IconSelector iconKey="linearloader" props={{top: '50%'}} />
                ) : (
                  <S.StatementBody>
                    <div>All your wallet transactions will be shown here</div>
                    <span>You haven’t done any wallet transaction for these dates.</span>
                  </S.StatementBody>
                )}
              </>
            )) ||
              null}
            {(walletData && walletData.length && (
              <S.MobileStatementInnerWrap>
                <S.FixedTableHeadMobile>
                  {(keys.length && (
                    <table>
                      <thead>
                        <tr>
                          {keys.map(item => (
                            <th key={item}>{item}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {walletData.map((item, i) => (
                          <WalletStatementRow item={item} key={`walletItem${i}`} />
                        ))}
                      </tbody>
                    </table>
                  )) ||
                    null}
                </S.FixedTableHeadMobile>
              </S.MobileStatementInnerWrap>
            )) ||
              null}
          </S.StatementMobileWrap>
        )}

        {/* <S.StatementActionsWrap>
          <S.ActionInnerWrap>
            <S.ActionIconWrap>
            </S.ActionIconWrap>
            <S.ActionTextWrap>Email Report</S.ActionTextWrap>
          </S.ActionInnerWrap>
          <S.ActionInnerWrap>
            <S.ActionIconWrap>
            </S.ActionIconWrap>
            <S.ActionTextWrap >Download Report</S.ActionTextWrap>
          </S.ActionInnerWrap>
        </S.StatementActionsWrap> */}
      </S.StatementInnerWrap>
    </S.StatementMainWrap>
  );
};

export default WalletStatement;
